// src/hooks/useTrades.js
import { useState, useEffect } from 'react';
import { SAMPLE_TRADES } from '../data/sampleTrades';

const STORAGE_KEY = 'odftrades_trades';
const SETTINGS_KEY = 'odftrades_settings';

const DEFAULT_SETTINGS = {
  dashboardPin: '1234',
  withdrawals: [],
  startingBalance: 0,
  riskPerTrade: 100,
  maxDailyLoss: 300,
  maxTradesPerDay: 3,
  maxDailyLosses: 2
};

export function useTrades() {
  const [trades, setTrades] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) return JSON.parse(stored);
    } catch {}
    // seed with sample data on first load
    localStorage.setItem(STORAGE_KEY, JSON.stringify(SAMPLE_TRADES));
    return SAMPLE_TRADES;
  });

  const [settings, setSettings] = useState(() => {
    try {
      const stored = localStorage.getItem(SETTINGS_KEY);
      if (stored) return JSON.parse(stored);
    } catch {}
    return DEFAULT_SETTINGS;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trades));
  }, [trades]);

  useEffect(() => {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  }, [settings]);

  const addTrade = (trade) => {
    const newTrade = { ...trade, id: crypto.randomUUID ? crypto.randomUUID() : Date.now().toString() };
    setTrades(prev => [newTrade, ...prev]);
    return newTrade;
  };

  const deleteTrade = (id) => {
    setTrades(prev => prev.filter(t => t.id !== id));
  };

  const updateTrade = (id, updates) => {
    setTrades(prev => prev.map(t => t.id === id ? { ...t, ...updates } : t));
  };

  const clearAll = () => {
    if (window.confirm('Clear all trades? This cannot be undone.')) {
      setTrades([]);
    }
  };

  return { trades, addTrade, deleteTrade, updateTrade, clearAll, settings, setSettings };
}
